import { render, staticRenderFns } from "./PreviewFile.vue?vue&type=template&id=0db470c6&scoped=true&"
import script from "./PreviewFile.vue?vue&type=script&lang=js&"
export * from "./PreviewFile.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFile.vue?vue&type=style&index=0&id=0db470c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db470c6",
  null
  
)

export default component.exports